var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"toast",style:({ background: _vm.options.background })},[_c('div',{staticClass:"toast-text",style:({ color: _vm.options.color }),domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }